import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    closeIcon: {
        border: `2px solid ${theme.palette.secondary.main}`,
        borderRadius: "100%",
        backgroundColor: theme.palette.background.eggShell,
        padding: theme.spacing(0.875),
        "& svg": {
            stroke: theme.palette.secondary.main,
        },
        "&:hover": {
            backgroundColor: theme.palette.background.eggShell,
        },
    },
}));
